import { render, staticRenderFns } from "./MatchExpiredStep.vue?vue&type=template&id=35613d49"
import script from "./MatchExpiredStep.vue?vue&type=script&lang=js"
export * from "./MatchExpiredStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports